import React, { useState } from "react";
import "./Gallery.css";

export const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    { id: 1, src: "/images/gallery/1.PNG", alt: "Valérie Perez lors d'un événement Destins de Femmes" },
    { id: 2, src: "/images/gallery/2.PNG", alt: "Lecture théâtrale Destins de Femmes au Théâtre du Rond-Point, Paris" },
    { id: 3, src: "/images/gallery/3.PNG", alt: "Remise du Prix Edgar Faure à Valérie Perez pour le livre Destins de Femmes" },
    { id: 4, src: "/images/gallery/4.PNG", alt: "Événement de sensibilisation aux droits des femmes organisé par l'ONG Destins de Femmes" },
    { id: 5, src: "/images/gallery/5.PNG", alt: "Rencontre avec le public lors d'un événement Destins de Femmes" },
    { id: 6, src: "/images/gallery/6.PNG", alt: "L'équipe de l'ONG Destins de Femmes lors d'un rassemblement" },
    { id: 7, src: "/images/gallery/7.PNG", alt: "Vente aux enchères caritative Destins de Femmes au profit de l'ONG" },
    { id: 9, src: "/images/gallery/9.PNG", alt: "Tournage d'un épisode de l'émission YouTube Destins de Femmes" },
    { id: 10, src: "/images/gallery/10.PNG", alt: "Moment de partage lors d'une conférence Destins de Femmes" }
  ];

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const nextImage = () => {
    const currentIndex = galleryImages.findIndex(img => img.id === selectedImage.id);
    const nextIndex = (currentIndex + 1) % galleryImages.length;
    setSelectedImage(galleryImages[nextIndex]);
  };

  const prevImage = () => {
    const currentIndex = galleryImages.findIndex(img => img.id === selectedImage.id);
    const prevIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    setSelectedImage(galleryImages[prevIndex]);
  };

  return (
    <div id="gallery" className="gallery-section">
      <div className="container">
        <div className="gallery-header">
          <div className="gallery-badge">
            <span className="badge-text">Galerie</span>
          </div>
          <h2 className="gallery-title">Moments inspirants</h2>
          <p className="gallery-subtitle">
            Découvrez en images les histoires inspirantes des femmes
            qui ont marqué le projet Destins de Femmes.
          </p>
        </div>

        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <div 
              key={image.id} 
              className={`gallery-item ${index % 3 === 0 ? 'large' : ''}`}
              onClick={() => openModal(image)}
            >
              <div className="image-wrapper">
                <img 
                  src={image.src} 
                  alt={image.alt}
                  loading="lazy"
                />
                <div className="image-overlay">
                  <div className="zoom-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M21 21L16.514 16.506M19 10.5C19 15.194 15.194 19 10.5 19S2 15.194 2 10.5 5.806 2 10.5 2 19 5.806 19 10.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M8 10.5H13M10.5 8V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Modal */}
        {selectedImage && (
          <div className="gallery-modal" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={closeModal}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              
              <button className="modal-nav modal-prev" onClick={prevImage}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              
              <img 
                src={selectedImage.src} 
                alt={selectedImage.alt}
                className="modal-image"
              />
              
              <button className="modal-nav modal-next" onClick={nextImage}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

